module.exports = __webpack_public_path__ + "img/1F1EC-1F1FA.79756a5a.svg";